import React from 'react';

import './index.scss';

type ButtonPillProps = {
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

const ButtonPill = ({ className: passedInClass, onClick, children }: ButtonPillProps): JSX.Element => {
  let className = "pill-button";
  if (!!passedInClass) {
    className +=` ${passedInClass}`;
  }

  return (
    <button
      className={className}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ButtonPill;